var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67603 11.0154C7.67603 11.9459 6.90698 12.7002 5.95831 12.7002C5.00965 12.7002 4.2406 11.9459 4.2406 11.0154M7.67603 11.0154C7.67603 10.0849 6.90698 9.33057 5.95831 9.33057C5.00965 9.33057 4.2406 10.0849 4.2406 11.0154M7.67603 11.0154H13.7757M4.2406 11.0154H0.700012V0.700195H13.7757V3.93229M18.4731 11.0154C18.4731 11.9459 17.704 12.7002 16.7554 12.7002C15.8067 12.7002 15.0377 11.9459 15.0377 11.0154M18.4731 11.0154C18.4731 10.0849 17.704 9.33057 16.7554 9.33057C15.8067 9.33057 15.0377 10.0849 15.0377 11.0154M18.4731 11.0154H19.7V8.23028L17.1059 3.93229H13.7757M15.0377 11.0154H13.7757M13.7757 3.93229V11.0154",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIcon);
export default __webpack_public_path__ + "static/media/truckIcon.c8b0cca47f7cae2e19b38c994068cfc0.svg";
export { ForwardRef as ReactComponent };